import React from 'react';
import './ProjectDetailModal.css';

// 1. Importa el logo desde la ruta local
import logoRyQ from '../../uploads/proyectos/ryq.png';
import { FaLocationDot } from "react-icons/fa6";


const ProjectDetailModal = ({ project, onClose }) => {
    if (!project) return null;

    // (La función getProjectDetails y el resto de la lógica se mantienen igual)
    const getProjectDetails = (projectId) => {
        switch (projectId) {
            case 1:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría del Contrato de Concesión, el cual hace parte del proyecto vial Ruta del Sol sector 2, entre Puerto Salgar – San Roque.',
                    totalProyecto: '528 kilómetros.',
                    plazoEjecucion: '81 meses',
                    inversion: 'USD 20.3 M',
                    consorcio: 'Consorcio Proyección Vial Puerto Salgar: R&Q INGENIERÍA COLOMBIA S.A – SERVINC S.A.S',
                    fechaTermino: 'Marzo 2019',
                    cliente: 'ANI, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 2:
                 return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría Concesión Bogotá (Fontibón) Facatativá – Los Alpes, que comprende los municipios de Mosquera, Madrid, Bojacá, Facatativá, Funza, La Mesa y Anapoima. El corredor vial inicia en el límite del perímetro urbano de Bogotá y termina en el sector de Los Alpes en Anapoima.',
                    totalProyecto: '67.2 kilómetros.',
                    plazoEjecucion: '54 meses',
                    inversion: 'USD 8.5 M',
                    consorcio: 'Consorcio Intervias: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Octubre 2018',
                    cliente: 'ANI, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 3:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría a las obras de construcción del Túnel de La Línea (8.65 km), los túneles cortos (9.28 km) y viaductos (2.5 km) del proyecto Cruce de la Cordillera Central, Quindio, Tolima.',
                    totalProyecto: '29 túneles y 31 viaductos.',
                    plazoEjecucion: '30 meses (fase 1)',
                    inversion: 'USD 65.0 M',
                    consorcio: 'Consorcio Interventoría Cruce de la Cordillera Central: R&Q Ingeniería Colombia S.A – Joyco S.A.S – Payc – Disraeli',
                    fechaTermino: 'En Ejecución',
                    cliente: 'INVÍAS, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 4:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría a las obras de construcción de la Concesión Cartagena – Barranquilla, Vía al mar, que comprende los municipios de Cartagena, Barranquilla, Puerto Colombia, Luruaco, Santa Catalina, Clemencia, Repelón, Baranoa, Piojó, Juan de Acosta, Usiacurí, Santo Tomás, Palmar de Varela y Ponedera.',
                    totalProyecto: '266 kilómetros.',
                    plazoEjecucion: '60 meses',
                    inversion: 'USD 7.5 M',
                    consorcio: 'Consorcio Interventoría Costera: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Octubre 2019',
                    cliente: 'ANI, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 5:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría al Sistema integrado de transporte masivo Metrocali, que comprende el diseño, construcción, operación y mantenimiento de la infraestructura y el material rodante.',
                    totalProyecto: '10 líneas troncales, 11 rutas alimentadoras.',
                    plazoEjecucion: '48 meses',
                    inversion: 'USD 2.8 M',
                    consorcio: 'Consorcio Interventoría Metrocali: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Agosto 2017',
                    cliente: 'METROCALI S.A., COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 6:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría a las obras de construcción de la Intersección a Desnivel de Puente Aranda, que comprende un puente vehicular, un paso a desnivel y un túnel.',
                    totalProyecto: '2 puentes, 1 paso a desnivel, 1 túnel.',
                    plazoEjecucion: '36 meses',
                    inversion: 'USD 3.2 M',
                    consorcio: 'Consorcio Interventoría Puente Aranda: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Diciembre 2016',
                    cliente: 'IDU, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 7:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría al mantenimiento del Aeropuerto Vanguardia, que comprende la pista, la plataforma, las calles de rodaje, la torre de control y las edificaciones.',
                    totalProyecto: '1 pista, 1 plataforma, 3 calles de rodaje.',
                    plazoEjecucion: '24 meses',
                    inversion: 'USD 1.5 M',
                    consorcio: 'Consorcio Interventoría Vanguardia: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Mayo 2015',
                    cliente: 'AEROCIVIL, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 8:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría al mantenimiento del Aeropuerto Alcaraván, que comprende la pista, la plataforma, las calles de rodaje, la torre de control y las edificaciones.',
                    totalProyecto: '1 pista, 1 plataforma, 2 calles de rodaje.',
                    plazoEjecucion: '24 meses',
                    inversion: 'USD 1.2 M',
                    consorcio: 'Consorcio Interventoría Alcaraván: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Abril 2015',
                    cliente: 'AEROCIVIL, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            case 9:
                return {
                    ubicacion: 'Colombia',
                    descripcion: 'Interventoría Concesión Transversal del Sisga, que comprende los municipios de Guasca, Gachetá, Ubalá, Gachalá, Gama y Sasaima.',
                    totalProyecto: '137 kilómetros.',
                    plazoEjecucion: '60 meses',
                    inversion: 'USD 5.0 M',
                    consorcio: 'Consorcio Interventoría Sisga: R&Q Ingeniería Colombia S.A – Joyco S.A.S',
                    fechaTermino: 'Junio 2018',
                    cliente: 'ANI, COLOMBIA.',
                    detailImageUrl: project.imageUrl
                };
            default:
                return {
                    ubicacion: 'Desconocida',
                    descripcion: 'Información no disponible para este proyecto.',
                    totalProyecto: '-',
                    plazoEjecucion: '-',
                    inversion: '-',
                    consorcio: '-',
                    fechaTermino: '-',
                    cliente: '-',
                    detailImageUrl: project.imageUrl
                };
        }
    };

    const projectDetails = getProjectDetails(project.id);

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}>&times;</button>
                
                <div className="modal-header">
                    <div className="header-text">
                        <p className="header-subtitle">PROYECTOS DESTACADOS</p>
                        <h2 className="modal-project-title">
                            {project.title}
                            <span className="title-orange-bar"></span>
                        </h2>
                    </div>
                    <img src={logoRyQ} alt="R&Q Ingeniería Logo" className="modal-logo" />
                </div>

                <div className="modal-body-grid">
                    <div className="modal-image-container">
                        <img src={projectDetails.detailImageUrl} alt={project.title} className="modal-project-image" />
                        <div className="modal-location">
                           {/* 2. REEMPLAZA EL SPAN CON EL COMPONENTE DEL ÍCONO */}
                           <FaLocationDot /> {projectDetails.ubicacion}
                        </div>
                    </div>
                    <div className="modal-details-col">
                        <p><span className="detail-label">Proyecto:</span> {projectDetails.descripcion}</p>
                        <p><span className="detail-label">Total del proyecto:</span> {projectDetails.totalProyecto}</p>
                        <p><span className="detail-label">Plazo de ejecución:</span> {projectDetails.plazoEjecucion}</p>
                        <p><span className="detail-label">Inversión:</span> {projectDetails.inversion}</p>
                    </div>
                </div>

                <div className="modal-footer-info">
                    <div className="footer-item">
                        <p className="footer-label">Consorcio:</p>
                        <p className="footer-value">{projectDetails.consorcio}</p>
                    </div>
                    <div className="footer-item">
                        <p className="footer-label">Fecha Término:</p>
                        <p className="footer-value">{projectDetails.fechaTermino}</p>
                    </div>
                    <div className="footer-item">
                        <p className="footer-label">Cliente:</p>
                        <p className="footer-value">{projectDetails.cliente}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetailModal;